import React, { Component } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import { appService } from '../../_services';
import { authHeader, config } from '../../_helpers'
import DocumentMeta from 'react-document-meta';

export class OrderPlaced extends Component {
    displayName = OrderPlaced.name

    constructor(props) {
        super(props);

        this.state = {
            OrderItem: [],
            totalTax: 0,
            totalShipping: 0,

        };

        this.ShortFormat = this.ShortFormat.bind(this);

    }

    getUrlParameter(name) {

        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(window.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    ShortFormat(date) {
        debugger;
        var month_names = ["Jan", "Feb", "Mar",
            "Apr", "May", "Jun",
            "Jul", "Aug", "Sep",
            "Oct", "Nov", "Dec"];
        var newdate = new Date(date);
        var day = newdate.getDate();
        var month_index = newdate.getMonth();
        var year = newdate.getFullYear();
        return;
    }

    componentDidMount() {
        var self = this;
        var OrderId = this.getUrlParameter('OrderId');

        appService.getAll('Cart/OrderPlaced?OrderId=' + OrderId).then(function (response) {
            var month_names = ["Jan", "Feb", "Mar",
                "Apr", "May", "Jun",
                "Jul", "Aug", "Sep",
                "Oct", "Nov", "Dec"];

            var newdate = new Date(response.orders.orderDate);
            var day = newdate.getDate();
            var month_index = newdate.getMonth();
            var year = newdate.getFullYear();
            let orderdate = "" + day + "-" + month_names[month_index] + "-" + year;

            self.setState({
                OrderId: response.orders.id,
                OrderNo: response.orders.orderNo,
                OrderDate: orderdate,
                OrderItem: response.orderProductVM,
                usersubscriptionid: response.usersubscriptionid,
                firstname: response.cartUserVM.firstname,
                lastname: response.cartUserVM.lastname,
                organisation: response.cartUserVM.organisation,
                countryId: response.cartUserVM.countryId,
                countryName: response.cartUserVM.countryName,
                countries: response.cartUserVM.countries,
                address1: response.cartUserVM.address1,
                address2: response.cartUserVM.address2,
                city: response.cartUserVM.city,
                regionId: response.cartUserVM.regionId,
                regionName: response.cartUserVM.regionName,
                regions: response.cartUserVM.regions,
                zip: response.cartUserVM.zip,
                phoneNo: response.cartUserVM.phoneNo,
                vatnumber: response.cartUserVM.vatnumber,
                emailAddress: response.cartUserVM.emailAddress,
                saveForQuickCheckout: response.cartUserVM.saveForQuickCheckout,
                //shipping
                shippingfirstname: response.cartUserVM.shippingFirstname,
                shippinglastname: response.cartUserVM.shippingLastname,
                //shippingorganisation: response.cartUserVM.shippingOrganisation,
                shippingcountryId: response.cartUserVM.shippingCountryId,
                shippingcountryName: response.cartUserVM.shippingCountryName,
                shippingcountries: response.cartUserVM.shippingcountries,
                shippingaddress1: response.cartUserVM.shippingAddress1,
                shippingaddress2: response.cartUserVM.shippingAddress2,
                shippingcity: response.cartUserVM.shippingCity,
                shippingregionId: response.cartUserVM.shippingRegionId,
                shippingregionName: response.cartUserVM.shippingRegionName,
                shippingregions: response.cartUserVM.shippingregions,
                shippingzip: response.cartUserVM.shippingZip,
                shippingphoneNo: response.cartUserVM.shippingPhoneNo,
                //shippingvatnumber: response.cartUserVM.shippingVatnumber,
                taxnumber: response.taxnumber.taxnumber1,
                //Tax
                totalTax: response.totalTax,
                totalShipping: response.totalShipping,
            });


        });

    }

    render() {
        const meta = {
            title: "Kluwer Law Online - Placed order",
            canonical: window.location.href,
        }

        var OrderItem = this.state.OrderItem;
        var totalAmount = 0;
        var totalCurrencySymbol = '';

        var totalTax = this.state.totalTax;
        var totalShipping = this.state.totalShipping;
        var cart = Object.entries(OrderItem).map((item) => {
            totalAmount += parseFloat(item[1].price * item[1].quantity)
            totalCurrencySymbol = item[1].currencySymbol
            return (<li className="list-group-item px-0 py-4" id={'dvitem_' + item[1].id}>
                <div className="row" >
                    <div className="col-lg-1 col-md-2 col-sm-2 col-4"><img alt="" height="120px" src={'./images/books/' + item[1].imageName} /></div>
                    <div className="col-lg-3 col-md-3 col-sm-3 col-6">
                        {(() => {

                            if (item[1].isDetailProduct == true) {
                                return (
                                    <p className="m-0 p-0 font-400"> <div dangerouslySetInnerHTML={{ __html: item[1].articleTitle }}></div></p>
                                )
                            }
                            else {
                                return (
                                    <p className="m-0 p-0 font-400"> <div dangerouslySetInnerHTML={{ __html: item[1].title }}></div></p>
                                )
                            }
                        }
                        )()}
                        <p className="m-0 p-0"><div dangerouslySetInnerHTML={{ __html: item[1].editors }}></div> </p>

                        {(() => {
                            if (item[1].isDetailProduct == true) {
                                return (
                                    <p className="m-0 p-0"> <div dangerouslySetInnerHTML={{ __html: item[1].title }}></div></p>
                                )
                            }
                        }
                        )()}

                    </div>

                    <div className="col-lg-2 col-md-1 col-sm-1 col-2" style={{ paddingLeft: '4%' }}>{item[1].quantity}</div>

                    <div className="col-lg-1 col-md-1 col-sm-1 col-3" >{item[1].documentType}</div>
                    <div className="col-lg-3 col-md-3 col-sm-3 col-6">


                        {(() => {
                            if (item[1].deliveryTypeId == 2 && item[1].fileName != null && item[1].code != null) {
                                if (item[1].documentType = 'Journal article') {
                                    return <a href={'api/Product/CitationPDFURL?file=Journals\\' + item[1].code + "\\" + item[1].fileName} target="_blank" dangerouslySetInnerHTML={{ __html: 'You can now download your PDF.<br/>' }} />
                                }
                                if (item[1].documentType = 'Manual chapter') {
                                    return <a href={'api/Product/CitationPDFURL?file=Manuals\\' + item[1].code + "\\" + item[1].fileName} target="_blank" dangerouslySetInnerHTML={{ __html: 'You can now download your PDF.<br/>' }} />
                                }
                                if (item[1].documentType = 'Encyclopedia chapter') {
                                    return <a href={'api/Product/CitationPDFURL?file=Encyclopedias\\' + item[1].code + "\\" + item[1].fileName} target="_blank" dangerouslySetInnerHTML={{ __html: 'You can now download your PDF.<br/>' }} />
                                }
                                //'You can now download your PDF.'
                            }
                        }
                        )()}

                        {item[1].deliveryType}</div>
                    <input type='hidden' value={item[1].price} id={'hdnPrice_' + item[1].id} />
                    <div id={'dvPrice_' + item[1].id} className="col-lg-1 col-md-1 col-sm-1 col-2 green">{item[1].currencySymbol}<span id={'spanPrice_' + item[1].id}>{(item[1].price * item[1].quantity).toFixed(2)}</span></div>

                </div>
            </li >)
        })

        return (
            <DocumentMeta {...meta}>
            <div className="col-12">
                <div className="row">
                    <div className="col-lg-12 colPadding margintop">

                        <p className="franziskafont">Thank you for placing your order! </p>
                        <p>You have successfully ordered the items listed below. </p>
                        <p>Please check your email for order confirmation (and relevant access details if relevant as described below).</p>

                        <div id="shoppingCart" className="mt-2">
                            <p className="PublicationTitle"></p>
                            <ul className="list-group list-group-flush mt-4">
                                <li className="list-group-item px-0 py-4">

                                    <div className="row">
                                        <div className="col-6">Order date</div>
                                        <div className="col-6">Order number</div>

                                    </div>
                                </li>

                                <li className="list-group-item px-0 py-4">
                                    <div className="row">
                                        <div className="col-6">
                                            <p>
                                                {this.state.OrderDate}

                                            </p> </div>

                                        <div className="col-6"><p>{this.state.OrderNo}</p></div>

                                    </div>
                                </li>
                            </ul>

                            <ul className="list-group list-group-flush">
                                <li className="list-group-item px-0 py-4">

                                    <div className="row">
                                        <div className="col-4">Product(s)</div>
                                        <div className="col-2">Quantity</div>
                                        <div className="col-1">Type</div>
                                        <div className="col-3">Access/delivery</div>
                                        <div className="col-1">Price</div>
                                    </div>
                                </li>
                                {cart}
                            </ul>
                            <div className="col border-bottom py-3 px-0">
                                <div className="row">
                                    <div className="col-md-9">
                                    </div>
                                    <div className="col col-md-1">Subtitle</div>
                                    <div className=" col col-md-1 green">{totalCurrencySymbol}<span id='spanTotalAmount'>{totalAmount.toFixed(2)}</span></div>
                                    <div className="col-1 d-none"></div>
                                </div>
                                <br></br>
                                <div className="row">
                                    <div className="offset-md-9 col col-md-1">VAT</div>
                                    <div className="col col-md-1 green">{totalCurrencySymbol}<span id='spanTotalVAT'>{totalTax.toFixed(2)}</span></div>
                                    <div className="col-1 d-none"></div>
                                </div> <br></br>
                                <div className="row">
                                    <div className="offset-md-9 col col-md-1">Shipping</div>
                                        <div className="col col-md-1 green">{totalCurrencySymbol}<span id='spanTotalShipping'>{totalShipping.toFixed(2)}</span></div>
                                    <div className="col-1 d-none"></div>
                                </div><br></br>
                                <div className="row">
                                    <div className="offset-md-9 col col-md-1 font-400">Total</div>
                                        <div className="col col-md-1 green font-400">{totalCurrencySymbol}<span id='spanGrandTotal'>{(totalAmount + totalTax + totalShipping).toFixed(2)}</span></div>
                                    <div className="col-1 d-none"></div>
                                </div><br></br>

                            </div>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item px-0 py-4 border-0">
                                    <div className="row">
                                        <div className="col col-lg-6 font-400">Company name</div>
                                        <div className="col font-400">VAT number</div>

                                    </div>
                                </li>
                                <li className="list-group-item px-0 py-4">
                                    <div className="row">
                                        <div className="col col-lg-6">{this.state.organisation}</div>
                                        <div className="col">{this.state.vatnumber}</div>

                                    </div>
                                </li>
                                <li className="list-group-item px-0 py-4">
                                    <div className="row">
                                        <div className="col col-lg-6 font-400">Billing address</div>
                                        <div className="col font-400">Shipping address</div>

                                    </div>
                                </li>
                                <li className="list-group-item px-0 py-4">
                                    <div className="row">
                                        <div className="col col-lg-6">
                                            <p className="m-0 p-0 ">{this.state.firstname + ' ' + this.state.lastname}<br></br>test <br></br>{this.state.address1} {this.state.address2} <br></br>{this.state.regionName}, {this.state.countryName} {this.state.phoneNo}</p>
                                        </div>
                                        <div className="col">
                                            {(() => {

                                                if (this.state.shippingaddress1 != null) {
                                                    return (
                                                        <p className="m-0 p-0">{this.state.shippingfirstname + ' ' + this.state.shippinglastname} <br></br>Wolters Kluwer <br></br>{this.state.shippingaddress1} {this.state.shippingaddress2} <br></br>{this.state.shippingregionName}, {this.state.shippingcountryName} {this.state.shippingphoneNo}</p>
                                                    )
                                                }

                                            }
                                            )()}
                                        </div>
                                        <div className="col blue"></div>
                                    </div>
                                </li>
                                <li className="list-group-item px-0 py-4">
                                    <div className="row">
                                        <div className="col col-lg-6 font-400">Email address</div>
                                        <div className="col font-400"></div>

                                    </div>
                                </li>
                                <li className="list-group-item px-0 py-4">
                                    <div className="row">
                                        <div className="col col-lg-6">{this.state.emailAddress}</div>
                                    </div>
                                </li>
                            </ul>
                            <div className="row my-5 ">
                                <div className="col"><a className="btn btn-info next float-right" href="/"><span>Back to kluwer law online</span></a></div>
                            </div>
                            <div className="row">
                                <div className="col col-lg-6">Kluwer Law International (VAT number: {this.state.taxnumber})</div>
                            </div>
                            <br></br>
                        </div>

                    </div>
                </div>
            </div>


                </DocumentMeta>
        );
    }
}

export default OrderPlaced;


// WEBPACK FOOTER //
// ./src/components/Shopping Cart/OrderPlaced.jsx